module.exports = __webpack_public_path__ + "img/svgCheck.30b5d754.svg";